// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__1p5Zk","clickable":"styles_clickable__312b_","disabled":"styles_disabled__2x3W_"};